import * as helios from "@hyperionbt/helios";
import { KreateUTxO } from "kreate-common/modules/business-types";
import { CLIENT_ENV } from "kreate-env/client";

import ScriptOffer from "../../onchain/scriptOffer.hl";
import {
  addHeliosCollateral,
  getCardanoNetworkParams,
  toHeliosUTxO,
} from "../../utils";

export async function buildTx$CancelOffer(
  wallet: helios.Cip30Wallet,
  utxoOffer: KreateUTxO,
  treasuryAddress: helios.Address,
  txMessage: string
) {
  const walletHelper = new helios.WalletHelper(wallet);
  const address = await walletHelper.baseAddress;

  const tx = new helios.Tx();
  await addHeliosCollateral(wallet, tx);

  const [utxos, remainingUtxos] = await walletHelper.pickUtxos(
    new helios.Value(BigInt(2_000_000)),
    helios.CoinSelection.selectSmallestFirst
  );
  tx.addInputs(utxos);

  const offerHeliosUTxO = toHeliosUTxO(utxoOffer);
  tx.addInput(offerHeliosUTxO, new helios.ConstrData(0, []));

  const scriptOffer = new ScriptOffer({
    TREASURY_ADDRESS: treasuryAddress,
  }).compile(true);
  tx.attachScript(scriptOffer);

  /** NOTE: @thanh-kreate
   * Since helios api does not automatically break a string that is less than 64
   * characters to array, this should be done manually to satisfy CIP-20 constraints
   * More details: https://cips.cardano.org/cips/cip20/
   * */
  tx.addMetadata(674, {
    map: [
      [
        "msg",
        helios.textToBytes(txMessage).length <= 64 ? [txMessage] : txMessage,
      ],
    ],
  });

  tx.addSigner(address.pubKeyHash);
  await tx.finalize(
    getCardanoNetworkParams(CLIENT_ENV.CARDANO_NETWORK),
    address,
    remainingUtxos
  );

  const txFee = Number(tx.body.fee);

  return { tx, txFee };
}
